import { createFileRoute } from '@tanstack/react-router';
import { TrashPage } from '@/features/tasks/trash-page';

export const Route = createFileRoute('/w/$workspaceId/trash')({ component: TrashPage });
